export default {"src":"/_next/static/media/Findrichanup-to-date-0001.3315f3d5.svg","height":585,"width":850,"blurWidth":0,"blurHeight":0};